// @module Paystand.PaystandExtensionV2.Paystand
define('Paystand.PaystandExtensionV2.Paystand.View'
,	[
	'paystand_paystandextensionv2_paystand.tpl'
	
	,	'Paystand.PaystandExtensionV2.Paystand.SS2Model'
	
	,	'Backbone'
    ]
, function (
	paystand_paystandextensionv2_paystand_tpl
	
	,	PaystandSS2Model
	
	,	Backbone
)
{
    'use strict';

	// @class Paystand.PaystandExtensionV2.Paystand.View @extends Backbone.View
	return Backbone.View.extend({

		template: paystand_paystandextensionv2_paystand_tpl

	,	initialize: function (options) {

			/*  Uncomment to test backend communication with an example service
				(you'll need to deploy and activate the extension first)
			*/

			// this.model = new PaystandModel();
			// var self = this;
         	// this.model.fetch().done(function(result) {
			// 	self.message = result.message;
			// 	self.render();
      		// });
		}

	,	events: {
		}

	,	bindings: {
		}

	, 	childViews: {

		}

		//@method getContext @return Paystand.PaystandExtensionV2.Paystand.View.Context
	,	getContext: function getContext()
		{
			//@class Paystand.PaystandExtensionV2.Paystand.View.Context
			this.message = this.message || 'Hello World!!'
			return {
				message: this.message
			};
		}
	});
});
